import * as documentsTypes from './documentsTypes';
import {
  // uploadDocsService,
  fetchClientsService,
  fetchDocTypesService,
  fetchEmployeesService,
  openDocumentAPI,
  deleteDocumentWithCaseDocumentAPI,
  getDocumentDetailsAPI,
  getDocumentDetailsHeaderAPI,
  fetchDocFieldsService,
  getFiltersAPI,
  getDocumentsAPI,
  saveDocUploadService,
} from 'src/services/documents.service';
import { showNotification } from 'src/utils/utilsActions';
import download from 'downloadjs';
import mime from 'mime-types';
import { getCasesPending } from 'src/ui/features/Cases/state/casesActions';
import intl from 'react-intl-universal';

export const getDocumentsSuccess = payload => {
  return dispatch => {
    dispatch({
      type: documentsTypes.GET_DOCUMENTS_SUCCESS,
      payload,
    });
  };
};

export const hydrateDocuments = payload => ({
  type: documentsTypes.HYDRATE_DOCUMENTS,
  payload,
});

export const getDocuments = (params, config) => {
  return async (dispatch, getState) => {
    const { documents, login } = getState();
    let paramsOptions = { ...params, isApplicant: login.userRoles.applicant };
    let configOptions = { ...config, isApplicant: login.userRoles.applicant };
    if (documents.appliedFilters) {
      paramsOptions = {
        ...documents.appliedFilters,
        ...params,
      };
    }

    let options = { ...paramsOptions, ...configOptions, expirationDayFilter: getExpirationDayFilter() };
    await getDocumentsAPI(options)
      .then(res => {
        if (res && !res.error) {
          dispatch(getDocumentsSuccess(res));
        } else {
          throw new Error('Error');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getDocumentsFailure = error => ({
  type: documentsTypes.GET_DOCUMENTS_FAILURE,
  error,
});

export const getFilters = config => {
  return async dispatch => {
    await getFiltersAPI(config)
      .then(res => {
        if (res && !res.error) {
          dispatch(hydrateDocumentsFilters(res));
        } else {
          throw new Error('Error');
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const appliedDocumentFilters = filters => ({
  type: documentsTypes.APPLIED_DOCUMENTS_FILTERS,
  filters,
});
export const hydrateDocumentsFilters = filters => ({
  type: documentsTypes.HYDRATE_DOCUMENTS_FILTERS,
  filters,
});

const getExpirationDayFilter = () => {
  const hash = decodeURI(window.location.hash.replace('#', ''));
  switch (hash) {
    case 'Expired':
      return 0;
    case '30 days':
      return 1;
    case '60 days':
      return 2;
    case '90 days':
      return 3;
    default:
      return null;
  }
};

export const getClientsSuccess = (data, index) => ({
  type: documentsTypes.GET_CLIENTS_SUCCESS,
  data,
  index,
});

export const getEmployeesSuccess = (data, index) => ({
  type: documentsTypes.GET_EMPLOYEES_SUCCESS,
  data,
  index,
});

export const getDocTypesSuccess = (data, index) => ({
  type: documentsTypes.GET_DOCUMENT_TYPES_SUCCESS,
  data,
  index,
});

export const getDocFieldsSuccess = (data, index) => ({
  type: documentsTypes.GET_DOCUMENT_FIELDS_SUCCESS,
  data,
  index,
});

export const saveDocSuccess = data => ({
  type: documentsTypes.GET_EMPLOYEES_SUCCESS,
  data,
});

export const resetDocUpload = () => ({
  type: documentsTypes.RESET_DOCUMENT_UPLOAD,
});

export const resetDocFields = index => ({
  type: documentsTypes.RESET_DOCUMENT_FIELDS,
  index,
});

export const deleteUpload = index => ({
  type: documentsTypes.DELETE_UPLOAD,
  index,
});

export const getDocFields = (params, index) => {
  return async dispatch => {
    const item = await fetchDocFieldsService(params);

    if (item) {
      dispatch(resetDocFields(index));
      dispatch(getDocFieldsSuccess(item.message, index));
    }
  };
};

export const getClients = index => {
  return async dispatch => {
    const { success, engagements } = await fetchClientsService();

    if (success) {
      dispatch(getClientsSuccess(engagements, index));
    }
  };
};

// open/download/delete files
export const deleteDocument = (documentId, notifText, fetchCallback, updateCaseCountCb, deleteNotification, isCase) => {
  return async dispatch => {
    dispatch(setDocumentsLoading(true));
    await deleteDocumentWithCaseDocumentAPI(documentId)
      .then(res => {
        // response is undefined when there's an error. Must fix this on the BE.
        if (res && !res.error) {
          dispatch(deleteDocumentSuccess(res));
          fetchCallback();
          updateCaseCountCb();
          isCase ? deleteNotification(notifText) : dispatch(showNotificationSuccess(notifText));
        } else {
          throw new Error('Error deleting document.');
        }
      })
      .catch(err => {
        console.error(err);
      });
    dispatch(setDocumentsLoading(false));
  };
};

export const setDocumentsLoading = isLoading => ({
  type: documentsTypes.SET_DOCUMENTS_LOADING,
  isLoading,
});

export const saveDocUpload = (data, notifText, errorText, callback) => {
  return async dispatch => {
    const promises = data.map(item => saveDocUploadService(item));
    const res = await Promise.all(promises);
    if (res && !res.error) {
      dispatch(showNotification(notifText, { variant: 'success' }));
      dispatch(resetDocUpload());
      callback();
    } else {
      dispatch(showNotification(errorText, { variant: 'error' }));
      callback();
    }
  };
};

export const showNotificationSuccess = message => ({
  type: documentsTypes.SHOW_DELETE_NOTIFICATION_SUCCESS,
  message,
});

export const hideNotificationSuccess = () => ({
  type: documentsTypes.HIDE_DELETE_NOTIFICATION_SUCCESS,
});

export const getDocTypes = (id, index) => {
  return async dispatch => {
    const { success, documenTypes } = await fetchDocTypesService(id);

    if (success) {
      dispatch(getDocTypesSuccess(documenTypes, index));
    }
  };
};

export const getEmployees = (id, index) => {
  return async dispatch => {
    const { success, employees } = await fetchEmployeesService(id);

    if (success) {
      dispatch(getEmployeesSuccess(employees, index));
    }
  };
};

export const deleteDocumentSuccess = payload => ({
  type: documentsTypes.DELETE_DOCUMENTS_SUCCESS,
  payload,
});

export const openDocument = documentId => {
  return async dispatch => {
    await openDocumentAPI(documentId).then(
      response => {
        if (response && !response.error && !response.errors) {
          let data = response.documentData;
          let fileName = response.fileName;
          let type = mime.lookup(fileName);
          download(atob(data), fileName, type);
        } else {
          let errorMsg = ' - ';
          if (response.error) {
            errorMsg += response.error.message;
          } else if (response.errors) {
            response.errors.forEach(error => {
              errorMsg += error.message + '\n';
            });
          } else {
            errorMsg = '';
          }
          dispatch(showNotification('Download failed' + errorMsg, { variant: 'error' }));
        }
      },
      error => {
        dispatch(showNotification('Download failed - ' + error.message, { variant: 'error' }));
      },
    );
  };
};

export const setDocumentId = data => ({
  type: documentsTypes.SET_DOCUMENT_ID,
  data,
});

export const uploadDocs = (data, isApplicant, isCase, clientId, index, callback) => {
  return async dispatch => {
    try {
      // const response = await uploadDocsService(data, {
      //   onUploadProgress: progressEvent => {
      //     if (typeof callback === 'function') {
      //       const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      //       callback(percentCompleted);
      //     }
      //   },
      // });

      // if (response.success) {
      if (isApplicant || isCase) {
        if (isApplicant) {
          dispatch(
            getCasesPending({
              caseStatusType: 'Open',
              viewType: 'applicantCase',
              pageNumber: 1,
              pageSize: 100,
              filter: true,
            }),
          );
        }
        dispatch(getDocTypes(clientId, index));
      } else {
        dispatch(getClients(index));
      }
      // dispatch(setDocumentId(response.documentId));
      // }
    } catch (err) {
      console.error(err);
    }
  };
};

export const getDocumentSucess = payload => ({
  type: documentsTypes.OPEN_DOCUMENTS_SUCCESS,
  payload,
});

export const getDocumentDetails = documentId => {
  return async dispatch => {
    dispatch(setDocumentsLoading(true));
    return await getDocumentDetailsAPI(documentId)
      .then(res => {
        dispatch(setDocumentsLoading(false));
        if (res) {
          dispatch(hydrateDocumentDetails(res));
          return res;
        } else {
          dispatch(deHydrateDocumentDetails());
          return res;
        }
      })
      .catch(err => {
        dispatch(setDocumentsLoading(false));
        console.error(err);
      });
  };
};

export const getDocumentDetailsHeader = (documentId, callback) => {
  return async dispatch => {
    return await getDocumentDetailsHeaderAPI(documentId)
      .then(res => {
        if (res && !res.error && !res.errors) {
          res.id = documentId;
          dispatch(getDocumentDetailsHeaderSuccess(res));
        } else {
          dispatch(showNotification(intl.get('documents.notifications.noAccess'), { variant: 'error' }));

          setTimeout(() => {
            callback();
          }, 3000);
        }
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const hydrateDocumentDetails = payload => ({
  type: documentsTypes.HYDRATE_DOCUMENT_DETAILS,
  payload,
});

export const deHydrateDocumentDetails = () => ({
  type: documentsTypes.DEHYDRATE_DOCUMENT_DETAILS,
});
export const storeCaseManagerId = id => ({
  type: documentsTypes.STORE_CASEMANAGER_ID,
  payload: id,
});

export const openDocumentsTab = () => ({
  type: documentsTypes.OPEN_DOCS_TAB,
  payload: true,
});

export const incrementDocCount = count => ({
  type: documentsTypes.INCREMENT_DOC_COUNT,
  payload: count,
});

export const getDocumentDetailsHeaderSuccess = payload => ({
  type: documentsTypes.GET_DOCUMENT_DETAIL_HEADER_SUCCESS,
  payload,
});

export default {
  getDocumentsSuccess,
  getDocuments,
  getDocumentsFailure,
  openDocument,
  deleteDocument,
  getDocumentDetails,
  hideNotificationSuccess,
  getFilters,
  storeCaseManagerId,
  deHydrateDocumentDetails,
  openDocumentsTab,
  incrementDocCount,
};
